import React from 'react';
import axios from 'axios';

class Footer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      newsletterEmail: '',
      subscribed: false,
    };
  }

  render() {
    const handleNewsletterForm = (event) => {
      event.preventDefault();
      const endpoint = `https://vk1gtwn5e7.execute-api.eu-west-1.amazonaws.com/prod/users/${this.state.newsletterEmail}`;

      return axios.post(endpoint)
      .then((response) => {
        this.setState({ subscribed: true });
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
    };

    const updateInputValue = (event) => {
      this.setState({ newsletterEmail: event.target.value });
    };

    return (
      <div id="global-footer">
        <div className="footer-content">
          { this.state.subscribed ?
            <div id="newsletter">
              <p>Thanks for signing up to the dyzio newsletter! It&#8217;s great to have you on board.</p>
            </div>
            :
            <div id="newsletter">
              <h2>Sign up to the newsletter</h2>
              <div className="spacer large" />
              <form id="newsletter-form" onSubmit={handleNewsletterForm}>
                <div className="newsletter-form">
                  <div className="item">
                    <input type="text" name="newsletterEmail" value={this.state.newsletterEmail} onChange={updateInputValue} placeholder="Email address" required />
                  </div>
                  <div className="item">
                    <button className="outline" type="submit">
                      <p>Sign up to our newsletter</p>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          }
          <div className="spacer large" />
          <ul>
            <li>
              <a href="https://twitter.com/dyziohq" target="_blank" rel="noopener noreferrer">
                <img src="https://static1.squarespace.com/static/ta/5891bf8f59cc682602b99910/48/assets/twitter.svg" alt="twitter" />
              </a>
            </li>
            <li>
              <a href="https://facebook.com/dyziohq" target="_blank" rel="noopener noreferrer">
                <img src="https://static1.squarespace.com/static/ta/5891bf8f59cc682602b99910/48/assets/facebook.svg" alt="facebook" />
              </a>
            </li>
            <li>
              <a href="https://instagram.com/dyziohq" target="_blank" rel="noopener noreferrer">
                <img src="https://static1.squarespace.com/static/ta/5891bf8f59cc682602b99910/48/assets/instagram.svg" alt="instagram" />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company-beta/10510767/" target="_blank" rel="noopener noreferrer">
                <img src="https://static1.squarespace.com/static/ta/5891bf8f59cc682602b99910/48/assets/linkedin.svg" alt="linkedin" />
              </a>
            </li>
            <li>
              <a href="mailto:info@dyzio.co">
                <img src="https://static1.squarespace.com/static/ta/5891bf8f59cc682602b99910/48/assets/email.svg" alt="email" />
              </a>
            </li>
          </ul>
          <div className="spacer" />
          <p className="small">Terms of use &nbsp;&nbsp;|&nbsp;&nbsp; Privacy &nbsp;&nbsp;|&nbsp;&nbsp; Blog</p>
          <div className="spacer" />
          <p className="small"><a href="mailto:info@dyzio.co">info@dyzio.co</a></p>
          <div className="spacer" />
          <p className="small light">© Dyzio Ltd. All rights reserved.</p>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js